import { render, staticRenderFns } from "./QuestionProgressBar.vue?vue&type=template&id=72b0f290&scoped=true&"
import script from "./QuestionProgressBar.vue?vue&type=script&lang=js&"
export * from "./QuestionProgressBar.vue?vue&type=script&lang=js&"
import style0 from "./question-progress-bar.scss?vue&type=style&index=0&id=72b0f290&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b0f290",
  null
  
)

export default component.exports